import React from 'react'
import CodingItem from './CodingItem'

const Coding = ({ data: { title, items} }) => {
    return (
        <div className="skills-list circles">
            <div className="skill-title border-line-h">
                <div className="icon"><i className="fa fa-code"></i></div>
                <div className="name">{title}</div>
            </div>
            <ul>
                {items.map((item, i) => (
                    <CodingItem key={`coding-${i}`} item={item} />
                ))}
            </ul>
        </div>
    )
}

export default Coding